export class ObjectTypes {
    public static UNASSIGNED: number = 0;
    public static WIRE: number = 1;
    public static RUNDOWN: number = 2;
    public static SCRIPT: number = 3;
    public static AUDIO: number = 4;
    public static VIDEO: number = 5;
    public static PICTURE: number = 6;
    public static READIN: number = 7;
    public static PLANNING: number = 8;
    public static MESSAGE: number = 9;
    public static GRID: number = 10;
    public static CONTACT: number = 11;
    public static NGGRID: number = 12;
    public static MOSOBJ: number = 13;
    public static ELECTION: number = 14;
    public static MOSOBJR: number = 15;
    public static OPENS: number = 16;
    public static APWORKBENCH: number = 17;
    public static EXTERNAL: number = 18;
    public static NONENPS: number = 19;
    public static STORYBOARD: number = 20;
    public static SEARCH: number = 21;
    public static GLOBALMACRO: number = 22;
    public static RUNDOWNMACRO: number = 23;
    public static STORYMACRO: number = 24;
    public static SOCIALMEDIAPOST: number = 25;
    public static SOCIALMEDIACOLLECTION: number = 26;
    public static USER: number = 29;
    public static PERSONALFOLDER: number = 110;
    public static PRINTER: number = 111;
    public static WIREFOLDER: number = 112;
    public static TRASHOPEN: number = 113;
    public static TRASHCLOSED: number = 114;
    public static LOCATIONS: number = 115;
    public static HOMEFOLDER: number = 116;
    public static GROUPFOLDER: number = 117;
    public static MOSLOGO: number = 118;
    public static DIRECTOR: number = 119;
    public static EDITOR: number = 120;
    public static RESEARCHER: number = 121;
    public static LOCATIONFOLDER: number = 122;
    public static WELCOME: number = 123;
    public static VOIPMESSAGE: number = 124;
    public static COMMCENTER: number = 125;
    public static TOOLBOX: number = 126;
    public static MACRO: number = 127;
    public static SCHEDULER: number = 128;
    public static MYENPS: number = 131;
    public static SOCIALMEDIA: number = 132;
    public static COLLECTIONCOLUMN: number = 133;
    public static TOPIC: number = 137;
    public static ASSIGNMENT: number = 138;
    public static PSTVIEWSTATE: number = 139;
    public static EXPORTFORMAT: number = 140;
    
    // PST Navigation related object types
    public static DRAFT: number = 162;
    public static PUBLICATION: number = 163;
    public static PUBLICATION_CHANNEL: number = 165;
    public static PUBLICATIONLIST: number = 164;

    public static _SEARCH: number = 999;

    public static isCollectionType(type: number): boolean {
        if ((type == ObjectTypes.RUNDOWN) || (type == ObjectTypes.NGGRID) || type == (ObjectTypes.STORYBOARD) || (type == ObjectTypes.TOPIC) || (type == ObjectTypes.PUBLICATIONLIST)) {
            return true;
        } else {
            return false;
        }
    }

    // Change all strings to capital case in the object below
    public static objectTypeReverseMapping: { [key: number]: string } = {
        [ObjectTypes.UNASSIGNED]: "Unassigned",
        [ObjectTypes.WIRE]: "Wire",
        [ObjectTypes.RUNDOWN]: "Rundown",
        [ObjectTypes.SCRIPT]: "Script",
        [ObjectTypes.AUDIO]: "Audio",
        [ObjectTypes.VIDEO]: "Video",
        [ObjectTypes.PICTURE]: "Picture",
        [ObjectTypes.READIN]: "Readin",
        [ObjectTypes.PLANNING]: "Planning",
        [ObjectTypes.MESSAGE]: "Message",
        [ObjectTypes.GRID]: "Grid",
        [ObjectTypes.CONTACT]: "Contact",
        [ObjectTypes.NGGRID]: "NGGrid",
        [ObjectTypes.MOSOBJ]: "MosObj",
        [ObjectTypes.ELECTION]: "Election",
        [ObjectTypes.MOSOBJR]: "MosObjR",
        [ObjectTypes.OPENS]: "Opens",
        [ObjectTypes.APWORKBENCH]: "APWorkbench",
        [ObjectTypes.EXTERNAL]: "External",
        [ObjectTypes.NONENPS]: "NonENPS",
        [ObjectTypes.STORYBOARD]: "Storyboard",
        [ObjectTypes.SEARCH]: "Search",
        [ObjectTypes.GLOBALMACRO]: "GlobalMacro",
        [ObjectTypes.RUNDOWNMACRO]: "RundownMacro",
        [ObjectTypes.STORYMACRO]: "StoryMacro",
        [ObjectTypes.SOCIALMEDIAPOST]: "SocialMediaPost",
        [ObjectTypes.SOCIALMEDIACOLLECTION]: "SocialMediaCollection",
        [ObjectTypes.USER]: "User",
        [ObjectTypes.PERSONALFOLDER]: "PersonalFolder",
        [ObjectTypes.PRINTER]: "Printer",
        [ObjectTypes.WIREFOLDER]: "WireFolder",
        [ObjectTypes.TRASHOPEN]: "TrashOpen",
        [ObjectTypes.TRASHCLOSED]: "TrashClosed",
        [ObjectTypes.LOCATIONS]: "Locations",
        [ObjectTypes.HOMEFOLDER]: "HomeFolder",
        [ObjectTypes.GROUPFOLDER]: "GroupFolder",
        [ObjectTypes.MOSLOGO]: "MosLogo",
        [ObjectTypes.DIRECTOR]: "Director",
        [ObjectTypes.EDITOR]: "Editor",
        [ObjectTypes.RESEARCHER]: "Researcher",
        [ObjectTypes.LOCATIONFOLDER]: "LocationFolder",
        [ObjectTypes.WELCOME]: "Welcome",
        [ObjectTypes.VOIPMESSAGE]: "VoipMessage",
        [ObjectTypes.COMMCENTER]: "CommCenter",
        [ObjectTypes.TOOLBOX]: "Toolbox",
        [ObjectTypes.MACRO]: "Macro",
        [ObjectTypes.SCHEDULER]: "Scheduler",
        [ObjectTypes.MYENPS]: "MyENPS",
        [ObjectTypes.SOCIALMEDIA]: "SocialMedia",
        [ObjectTypes.COLLECTIONCOLUMN]: "CollectionColumn",
        [ObjectTypes.TOPIC]: "Topic",
        [ObjectTypes.ASSIGNMENT]: "Assignment",
        [ObjectTypes.PSTVIEWSTATE]: "PSTViewState",
        [ObjectTypes.EXPORTFORMAT]: "ExportFormat",
        [ObjectTypes.DRAFT]: "Draft",
        [ObjectTypes.PUBLICATION]: "Publication",
        [ObjectTypes.PUBLICATION_CHANNEL]: "PublicationChannel",
        [ObjectTypes.PUBLICATIONLIST]: "PublicationList",
        [ObjectTypes._SEARCH]: "_SEARCH"
    };

}
